import { Injectable, WritableSignal, signal } from '@angular/core';
import {
    BLOG_SEARCH_CRITERIA,
    IIqLinksBlogArticle,
    IIqLinksBlogSearchCriteriaInput,
    IIqLinksBlogStateService,
} from '../../models';
import { gql } from 'apollo-angular';
import { DatiqGraphqlApolloService } from '@dat/datiq-graphql';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class IqLinksBlogStateService implements IIqLinksBlogStateService {
    constructor(private readonly _apollo: DatiqGraphqlApolloService) {}

    getArticles(limit: number): WritableSignal<IIqLinksBlogArticle[]> {
        const valueSignal = signal<IIqLinksBlogArticle[]>([]);

        const linksQuery: IIqLinksBlogSearchCriteriaInput =
            BLOG_SEARCH_CRITERIA;

        firstValueFrom(
            this._apollo
                .getApollo()
                .query<{ wordpressLinks: IIqLinksBlogArticle[] }>({
                    query: articlesQuery,
                    variables: {
                        linksQuery,
                    },
                }),
        )
            .then((response) => {
                const links = response?.data?.wordpressLinks ?? [];

                valueSignal.set(links.slice(0, limit));
            })
            .catch((err) => {
                console.error('error fetching blog links:', err);
            });

        return valueSignal;
    }
}

const articlesQuery = gql`
    query ($linksQuery: SOCIAL_SearchCriteriaInputSocial) {
        wordpressLinks: getWordpressLinks(query: $linksQuery) {
            id
            name
            date
            url
            description
        }
    }
`;
